import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatCategoryPromoterModel } from 'src/app/model/cat-category-promoter.model';
import { CatCategoryPromoterService } from 'src/app/services/cat-category-promoter.service';

@Component({
  selector: 'app-modal-category-promoter-catalog',
  templateUrl: './modal-category-promoter-catalog.component.html',
  styleUrls: ['./modal-category-promoter-catalog.component.css']
})
export class ModalCategoryPromoterCatalogComponent implements OnInit {
  @Input() category: CatCategoryPromoterModel;
  @Input() mode: string;

  // estado pagina
  public viewStatus = 1;

  // mascaras
  public customPatterns = {
    'A': { pattern: new RegExp('[a-zA-Z0-9ñÑ ]') },
    'C': { pattern: new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]') },
    'N': { pattern: new RegExp('[0-9]') }
  };

  ////////////////
  constructor(
    private categoryPromoterService: CatCategoryPromoterService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }
  ngOnInit() { }

  //
  toggleActive = () => this.category.activeId = this.category.activeId ? 0 : 1;
  isValid = () => {
    let valid = true;
    let errors = [];
    if (this.descriptionError()) errors.push('Necesita capturar una descripción.');
    if (errors.length > 0) {
      valid = false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', { enableHtml: true });
    }
    return valid;
  }
  save = () => {
    if (this.isValid()) {
      // mostrar spinner
      this.viewStatus = 0;
      // enviar informacion
      this.category.description = this.category.description.toUpperCase();
      this.categoryPromoterService.save(this.category)
        .pipe(
          tap((resp: any) => {
            if (resp && resp.codeHttpStatus === 200) {
              this.modalService.dismissAll('success');
              this.toastr.success('La categoría se guardó con éxito.');
            } else {
              this.viewStatus = 1;
              this.toastr.error(resp && resp.messageError ? resp.messageError : 'Ocurrió un error al intentar guardar la categoría.');
            }
          }),
          catchError(error => {
            this.viewStatus = 1;
            return of(this.toastr.error('Ocurrió un error al intentar guardar la categoría.'));
          })
        )
        .subscribe();
    }
  }
  close = () => this.modalService.dismissAll();

  // HELPERS
  descriptionError = () => !this.category.description || this.category.description.trim() === '';
}
